// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__Xht5n","formControl":"addForm_formControl__waylv","list":"addForm_list__W7hNb","btnWrpper":"addForm_btnWrpper__9RBiR"};